module.exports = __webpack_public_path__ + "img/companyNameImg.4b11363a.png";